import { render, staticRenderFns } from "./articleSingle.vue?vue&type=template&id=e827dd92&"
import script from "./articleSingle.vue?vue&type=script&lang=js&"
export * from "./articleSingle.vue?vue&type=script&lang=js&"
import style0 from "./articleSingle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VCardSubtitle,VIcon,VImg,VOverlay})
